var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')
var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpText = require('./ReUpText');
var PlatformConstants = require('./constants/PlatformConstants');
var Sound = require('./wrappers/react-native-sound-wrapper');
Sound.setCategory('Playback');
var Icon = require('./wrappers/ReUpIcon');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  AppState,
  Platform,
  StyleSheet,
  Keyboard,
} = ReactNative;

var Camera = require('./wrappers/react-native-camera-wrapper');

var creditQR = {"Type":"credit","AppID":"reup0","U":"101","H":"610aa656aa","T":0,"TT":"P"}
var rewardQR = {T:'reward',R:'5',"AppID":"reup0",U:'251',"H":'377b46debc'};
var checkinQR = {Type:'checkin',"AppID":"reup0","U":"101","H":"35a964eff9"};
var passQR = {Type:'pass', P: '1', "AppID":"reup0",U:'2',"H": '99dd4cc155'};
var giftCardQR = {"U":"15","T":"GC","H":"ce1086dedd"};//{T:'GC',"AppID":"reup0",U:'101',H:'610aa656aa'};
var garbageQR = "asdfasdf";

const MAX_SCAN_TRIES = 3;

var beep = null

var TransactionScan = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      isDebugging : false,
      extras : {}
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      isScanning : false,
      buttonOpacity:new Animated.Value(0),
      qrCodeOpacity:new Animated.Value(0),
      showPhoneButton: true,
      hasPermission: Platform.OS !== 'ios' // only need to request on ios for now
    }
  },

  componentDidMount : function()
  {
    beep = new Sound('beep.mp3', Sound.MAIN_BUNDLE, (error) => {
      if (error) {
        return;
      }
      // loaded successfully
    });
    Keyboard.dismiss();
    var thisThing = this;

    if( !this.state.hasPermission )
    {
      const someAsyncFunction = async () => {

      }
    }
    else
    {
      setTimeout(function()
      {
        thisThing.scan();
      },200)
    }

    this.props.appManager._eventEmitter.on('stopScan', this.stopScan, this)
    AppState.addEventListener('change', this._handleAppStateChange);
  },

  componentWillUnmount: function()
  {
    AppState.removeEventListener('change', this._handleAppStateChange);
    this.props.appManager._eventEmitter.removeListener('stopScan', this.stopScan, this);
  },

  getPermission: async function(succeeded, failed)
  {
    if(await Camera.checkVideoAuthorizationStatus()) {
     succeeded();
    } else {
     failed();
    }
  },

  _handleAppStateChange: function(appState)
  {
    if( appState == 'active' )
    {
      // this.scan();
    }
    else
    {
      this.stopScan();
    }
  },

  didUpdate(data)
  {
    if( typeof data.Rewards !== 'undefined' )
    {
      this._rewards = data.Rewards;
      this._passes = data.Passes;
    }
  },

  _qrCodePulsing : false,
  setQRCodePulsing : function(enable)
  {
    if( enable != this._qrCodePulsing )
    {
      if( enable )
      {
        this.fadeInQRCode();
      }
      this._qrCodePulsing = enable;
    }
  },

  fadeInQRCode : function()
  {
    var thisThing = this;
    Animated.timing(
     thisThing.state.qrCodeOpacity,
     {toValue: 1,
     duration:700},
    ).start(function()
    {
      if( thisThing._qrCodePulsing ) thisThing.fadeOutQRCode();
    });
  },

  fadeOutQRCode : function()
  {
    var thisThing = this;
    Animated.timing(
     thisThing.state.qrCodeOpacity,
     {toValue: 0,
     duration:700},
    ).start(function()
    {
      if( thisThing._qrCodePulsing ) thisThing.fadeInQRCode();
    });
  },

  _scannerTimeout : null,
  _SCANNER_TIMEOUT_SECONDS : 60,
  scan : function()
  {
    var thisThing = this;
    thisThing._scanTries = 0;
    var appActions = this.props.appActions;
    if( Platform.OS == 'ios' )
    {
      this.getPermission(()=>
      {
        thisThing._hasScanned = false;
        thisThing._scannerTimeout = setTimeout(function()
        {
          thisThing.stopScan();
        },thisThing._SCANNER_TIMEOUT_SECONDS*1000)
        thisThing.setState({isScanning:true, hasPermission:true});
      }, ()=>
      {
        appActions.showLocalizedAlert("Camera Permission Error", "To use the scanner, the camera permission must be turned on. Please enable the camera for this app in your device settings.", ["OK_ALERT_BUTTON"], [function()
        {
          appActions.hideAlert();
        }], function(){})
      })
    }
    else
    {
      thisThing._hasScanned = false;
      thisThing.setState({isScanning:true, hasPermission:true});
    }
  },

  stopScan : function()
  {
    if( this._scannerTimeout != null )
    {
      clearTimeout(this._scannerTimeout);
      this._scannerTimeout = null;
    }
    this.setState({isScanning:false});
  },

  _rewards: [],
  getReward : function(rewardID, userID, hash, completion)
  {
    for( var i = 0; i < this._rewards.length; i++ )
    {
      if( this._rewards[i].rewardID == rewardID )
      {
        completion(this._rewards[i]);
        return;
      }
    }

    var thisThing = this;
    var appActions = this.props.appActions;
    appActions.setSpinnerShown("Fetching Rewards...");
    NetworkManager.updateFeature(this.props.appManager, "Rewards", function(data)
    {
      thisThing._rewards = data;
      for( var i = 0; i < thisThing._rewards.length; i++ )
      {
        if( thisThing._rewards[i].RewardID == rewardID )
        {
          appActions.setSpinnerShown(false);
          completion(thisThing._rewards[i]);
          return;
        }
      }
      // if not found, try to get one time reward
      NetworkManager.getOneTimeRewards(thisThing.props.appManager, userID, hash, function(oneTimeRewards)
      {
        appActions.setSpinnerShown(false);
        for( var i = 0; i < oneTimeRewards.length; i++ )
        {
          thisThing._rewards.push(oneTimeRewards[i]);
          if( oneTimeRewards[i].RewardID == rewardID )
          {
            completion(oneTimeRewards[i]);
            return;
          }
        }
        completion(null);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        completion(null);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        completion(null);
        appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert)
      })
    }, function(data)
    {
      appActions.setSpinnerShown(false);
      completion(null);
    }, function(data)
    {
      appActions.setSpinnerShown(false);
      completion(null);
      appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert)
    })
  },

  _passes: [],
  getPass : function(passID, completion)
  {
    for( var i = 0; i < this._passes.length; i++ )
    {
      if( this._passes[i].passID == passID )
      {
        completion(this._passes[i]);
        return;
      }
    }

    var thisThing = this;
    var appActions = this.props.appActions;
    appActions.setSpinnerShown("Fetching Passes...");
    NetworkManager.updateFeature(this.props.appManager, "Passes", function(data)
    {
      appActions.setSpinnerShown(false);
      thisThing._passes = data;
      for( var i = 0; i < thisThing._passes.length; i++ )
      {
        if( thisThing._passes[i].PassID == passID )
        {
          completion(thisThing._passes[i]);
          return;
        }
      }
      completion(null);
    }, function(data)
    {
      appActions.setSpinnerShown(false);
      completion(null);
    }, function(data)
    {
      appActions.setSpinnerShown(false);
      completion(null);
      appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert)
    })
  },

  _hasScanned :false,
  didScanData : function(data)
  {
    if( this._hasScanned ) return;
    this._hasScanned = true;

    // Play the sound with an onEnd callback
    beep.play((success) => {
    });

    var thisThing = this;
    try {
      var appActions = this.props.appActions;
      var appManager = this.props.appManager;
      var locManager = appManager.getLocalizationManager();
      var jsonString = atob(data);
      var obj = JSON.parse(jsonString);
      var extras = data;
      if( obj )
      {
        var scannerAppID = appManager.currentUser().AppID;
        var qrAppID = obj.AppID;
        var userID = typeof obj.U !== 'undefined' ? obj.U : (typeof obj.UserID !== 'undefined' ? obj.UserID : -1);
        var type = typeof obj.T !== 'undefined' ? obj.T : (typeof obj.Type !== 'undefined' ? obj.Type : 'credit');
        var rewardID = typeof obj.R !== 'undefined' ? obj.R : (typeof obj.RewardID !== 'undefined' ? obj.RewardID : '');
        var passID = typeof obj.P !== 'undefined' ? obj.P : (typeof obj.PassID !== 'undefined' ? obj.PassID : '');
        var hash = typeof obj.H !== 'undefined' ? obj.H : (typeof obj.Hash !== 'undefined' ? obj.Hash : '');
        obj.userID = userID;
        obj.type = type;
        obj.rewardID = rewardID;
        obj.passID = passID;
        obj.hash = hash;
        if( qrAppID != scannerAppID && !(type == "GC" || type == "giftcard") )// dont do check for gc
        {
          thisThing.stopScan();
          var QRalertTitle = locManager.localizedStringForKey("INVALID_QR_CODE_SCANNER_ALERT_TITLE", "Invalid QR Code");
          var QRalertBody = locManager.localizedStringForKey("INVALID_QR_CODE_SCANNER_ALERT_BODY", "This QR Code is not for your store.");
          var okButton = locManager.localizedStringForKey("OK_ALERT_BUTTON", "OK");
          appActions.showAlert(QRalertTitle, QRalertBody, [okButton], [function()
            {
            thisThing.scan();
            appActions.hideAlert();
          }], function(){})
          return;
        }
        if( type == "GC" || type == "giftcard" ) // is gift card
        {
          this.stopScan()
          appActions.setSpinnerShown(true, "Retrieving User...");
          NetworkManager.getGCInfoByUserIDVendor(appManager, userID, hash, function(data)
          {
            var qrcode = obj;
            for( var key in data )
            {
              qrcode[key] = data[key];
            }
            // this is a hack for the cap sensitivity
            if( typeof qrcode.PhoneNumber !== 'undefined' ) qrcode.phoneNumber = qrcode.PhoneNumber;
            qrcode.scanner = thisThing;
            qrcode.hash = hash;
            appActions.setSpinnerShown(false);
            appActions.requestFeatureName("GiftCardOptions",qrcode)
          }, function(data)
          {
            appActions.setSpinnerShown(false);
            appActions.showLocalizedAlert("Error", "Unable to get gift card info.", ["OK_ALERT_BUTTON"], [function()
            {
              thisThing.scan();
              appActions.hideAlert()
            }], appActions.hideAlert)
          }, function(data)
          {
            appActions.setSpinnerShown(false);
            appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert)
          })

        }
        else if( type == "R" || type == "reward" || rewardID.length > 0 ) // redeem reward
        {
          this.stopScan();
          var rewardID = typeof obj.R !== 'undefined' ? obj.R : -1;
          var hash =  typeof obj.H !== 'undefined' ? obj.H : (typeof obj.Hash !== 'undefined' ? obj.Hash : -1);
          this.getReward(rewardID, userID, hash, function(reward)
          {
            if( reward == null )
            {
              appActions.showLocalizedAlert("Invalid Reward", "This reward no longer exists.", ["OK_ALERT_BUTTON"], [function()
              {
                appActions.hideAlert();
                thisThing.scan();
              }], function(){})
            }
            else
            {
              var rewardName = reward.RewardName;
              appActions.showLocalizedAlert(rewardName, "Allow this customer to redeem for reward: "+rewardName+"?", ["NO_ALERT_BUTTON","YES_ALERT_BUTTON"], [function()
              {
                appActions.hideAlert();
                thisThing.scan();
              },function()
              {
                appActions.hideAlert();
                var redeemingSpinner = locManager.localizedStringForKey("REDEEMING_SPINNER","Redeeming...")
                appActions.setSpinnerShown(true, redeemingSpinner);
                NetworkManager.vendorRedeemReward(appManager, userID, rewardID, type, hash, function(data)
                {
                  appActions.setSpinnerShown(false);
                  data.success = true;
                  data.scanner = thisThing;
                  data.isReward = true;
                  data.reward = reward;
                  appActions.requestFeatureName("TransactionResult", data);
                }, function(data)
                {
                  appActions.setSpinnerShown(false);
                  data.success = false;
                  data.scanner = thisThing;
                  data.reward = reward;
                  appActions.requestFeatureName("TransactionResult", data);
                }, function(data)
                {
                  appActions.setSpinnerShown(false);
                  appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert)
                })
              }], function(){})
            }
          })
        }
        else if( type == "P" || type == "pass" || passID.length > 0 ) // redeem pass
        {
          this.stopScan();
          var passID = typeof obj.P !== 'undefined' ? obj.P : -1;
          var hash =  typeof obj.H !== 'undefined' ? obj.H : (typeof obj.Hash !== 'undefined' ? obj.Hash : -1);
          this.getPass(passID, function(pass)
          {
            if( pass == null )
            {
              appActions.showLocalizedAlert("Invalid Pass", "This pass no longer exists.", ["OK_ALERT_BUTTON"], [function()
              {
                appActions.hideAlert();
                thisThing.scan();
              }], function(){})
            }
            else
            {
              var passName = pass.Name;
              var validPassTitle = locManager.localizedStringForKeyAndParams("ALLOW_CUSTOMER_REDEEM_PASS_ALERT_BODY", [passName], "Allow this customer to redeem pass: %0%?");
              var nobutton = locManager.localizedStringForKey("NO_ALERT_BUTTON", "No");
              var yesButton = locManager.localizedStringForKey("YES_ALERT_BUTTON", "Yes");
              appActions.showAlert(passName, validPassTitle, [nobutton,yesButton], [function()
              {
                appActions.hideAlert();
                thisThing.scan();
              },function()
              {
                appActions.hideAlert();
                appActions.setSpinnerShown(true, "Redeeming...");
                NetworkManager.vendorRedeemPass(appManager, userID, passID, hash, function(data)
                {
                  appActions.setSpinnerShown(false);
                  data.success = true;
                  data.scanner = thisThing;
                  data.isPass = true;
                  data.pass = pass;
                  appActions.requestFeatureName("TransactionResult", data);
                }, function(data)
                {
                  appActions.setSpinnerShown(false);
                  data.success = false;
                  data.scanner = thisThing;
                  data.pass = pass;
                  appActions.requestFeatureName("TransactionResult", data);
                }, function(data)
                {
                  appActions.setSpinnerShown(false);
                  appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert)
                })
              }], function(){})
            }
          })
        }
        else if( type == "checkin" ) // checkin
        {
          setTimeout(this.stopScan, 1000);
          var userID = typeof obj.U !== 'undefined' ? obj.U : (typeof obj.UserID !== 'undefined' ? obj.UserID : -1);
          obj.scanner = thisThing;
          obj.userID = userID;
          obj.hash =  typeof obj.H !== 'undefined' ? obj.H : (typeof obj.Hash !== 'undefined' ? obj.Hash : -1);
          this.props.appActions.requestFeatureName("CheckInInput",obj);
        }
        else // must be credit
        {
          setTimeout(this.stopScan, 1000);
          obj.scanner = thisThing;
          this.props.appActions.requestFeatureName("CreditInput",obj);
        }
      }
    } catch (e) {
      thisThing._scanTries++;
      if( thisThing._scanTries >= MAX_SCAN_TRIES )
      {
        appActions.showLocalizedAlert("Invalid QR Code", "Please only scan ReUp app, gift card or pass QR codes from your own account.", ["OK_ALERT_BUTTON"], [function()
        {
          appActions.hideAlert();
        }], function(){})
        thisThing.stopScan();
      }
      thisThing._hasScanned = false;
    } finally {
    }

  },

  verifyLogout: function()
  {
    TransactionScan.backOverride(this.props.appManager, this.props.appActions);
  },

  render: function()
  {
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var feedFeatureData = appManager.getFeatureForName("DomainLogin");
    var thisThing = this;

    var cardColor = appManager.getColorForKey("FeedCardColor");
    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");


    var bgImage = appManager.absoluteResourceForPath(feedFeatureData.data.name + "/" + feedFeatureData.data.bgImage);
    var cameraDim = Math.min(this.state.layout.width,this.state.layout.height - 200) - 20;
    var cameraAspectRatio = 4/3;

    var user = appManager.currentUser();
    var shouldShowScanner = true;
    var shouldShowPhone = true;
    if( user != null && typeof user.ReUpPackage !== 'undefined' && user.ReUpPackage.length > 0 )
    {
      var reUpPackage = JSON.parse(user.ReUpPackage);
      if( typeof reUpPackage.options !== 'undefined' )
      {
        if( typeof reUpPackage.options.enableScan !== 'undefined' ) shouldShowScanner = reUpPackage.options.enableScan;
        if( typeof reUpPackage.options.enablePhone !== 'undefined' ) shouldShowPhone = reUpPackage.options.enablePhone;
      }
    }

    return (
      <View style={[styles.container, {backgroundColor:generalColor}]}>
        <ReUpScrollView responder={this}>
          <View style={{flexDirection:'row', alignItems:'center'}}>
            <View style={{width:0, height:this.props.initialLayout.height}} />
            <View style={{flexDirection:'column', flex:1}}>
            {
              this.state.isScanning && shouldShowScanner ?
              <View style={{padding:10}}>
                <Camera style={{alignSelf:'center', height:cameraDim, width:cameraDim, justifyContent:'center', marginTop:20}}
                      barCodeTypes={[Camera.constants.BarCodeType.qr]}
                      captureAudio={false}
                      type={Camera.constants.Type.back}
                      aspect={Camera.constants.Aspect.Fill}
                      onBarCodeRead={(evt)=>
                      {
                        // {"data":"eyJVIjoiMTUwIiwiVCI6IkdDIiwiSCI6IjIyMGY2ZWNjZDIifQ==","type":"org.iso.QRCode","bounds":{"size":{"width":"0.377938","height":"0.672479"},"origin":{"x":"0.348706","y":"0.132129"}}}
                        thisThing.didScanData(evt.data);
                      }}>
                    <Animated.View style={{opacity:thisThing.state.qrCodeOpacity}}><Icon name={"qrcode"} size={200} color={'black'} style={{backgroundColor:'transparent',justifyContent:'center', alignSelf:'center', padding:0, paddingBottom:0, lineHeight:216}}/></Animated.View>
                </Camera>
              </View>
              :
              <View style={{padding:10}}>
              {
                shouldShowScanner ?
                  <View style={{alignSelf:'center', height:cameraDim, width:cameraDim, justifyContent:'center', marginTop:20, alignItems:'center', backgroundColor:'white', borderRadius:10}}>
                      <ReUpText isTitle={true} style={{color:generalTitleColor, textAlign:'center'}}>Select "Scan" to begin!</ReUpText>
                      {
                        typeof appManager._lastTransaction !== 'undefined' ?
                          <ReUpButton isSecondary={true} style={[styles.button,{margin:10, alignSelf:'stretch', paddingLeft:20, paddingRight:20}]}
                            appManager={appManager}
                            text={locManager.localizedStringForKey("VIEW_PREVIOUS_TRANSACTION_BUTTON")}
                            onPress={() =>
                            {
                              appActions.requestFeatureName("TransactionResult", appManager._lastTransaction)
                            }}
                            />
                        : null
                      }
                      <ReUpButton isSecondary={true} style={[styles.button,{margin:10, alignSelf:'stretch', paddingLeft:20, paddingRight:20}]}
                        appManager={appManager}
                        text={locManager.localizedStringForKey("VIEW_REFUNDS_BUTTON")}
                        onPress={() =>
                        {
                          appActions.requestFeatureName("Refunds")
                        }}
                        />
                  </View>
                : null
              }
              </View>
              }
              {
                shouldShowScanner ?
                <View style={{marginHorizontal:10}}>
                {
                  this.state.isScanning ?
                  <ReUpButton style={[styles.button,{marginTop:20}]}
                    appManager={appManager}
                    text={locManager.localizedStringForKey("STOP_SCAN_BUTTON")}
                    onPress={() =>
                    {
                      thisThing.stopScan();
                    }}
                    />
                  :
                  <ReUpButton style={[styles.button,{marginTop:20}]}
                    appManager={appManager}
                    text={locManager.localizedStringForKey("SCAN_BUTTON")}
                    onPress={() =>
                    {
                      thisThing.scan();
                    }}
                    />
                }
                </View>
                : null
              }
              {
                shouldShowPhone ?
                  <ReUpButton style={[styles.button,{marginTop:8, marginHorizontal:10}]}
                    appManager={appManager}
                    text={locManager.localizedStringForKey("INPUT_PHONE_BUTTON")}
                    onPress={() =>
                    {
                      thisThing.stopScan();
                      appActions.requestFeatureName("PhoneLoyaltyInput")
                    }}
                    />
                : null
              }
              {
                !shouldShowScanner ?
                  <ReUpButton isSecondary={true} style={[styles.button,{margin:10, alignSelf:'stretch', paddingLeft:20, paddingRight:20}]}
                    appManager={appManager}
                    text={locManager.localizedStringForKey("VIEW_REFUNDS_BUTTON")}
                    onPress={() =>
                    {
                      appActions.requestFeatureName("Refunds")
                    }}
                    />
                : null
              }
              {
                typeof appManager._lastTransaction !== 'undefined' && !shouldShowScanner ?
                  <ReUpButton isSecondary={true} style={[styles.button,{margin:10, alignSelf:'stretch', paddingLeft:20, paddingRight:20}]}
                    appManager={appManager}
                    text={locManager.localizedStringForKey("VIEW_PREVIOUS_TRANSACTION_BUTTON")}
                    onPress={() =>
                    {
                      appActions.requestFeatureName("TransactionResult", appManager._lastTransaction)
                    }}
                    />
                : null
              }
              <ReUpButton isSecondary={true} style={[styles.button,{margin:10}]}
                appManager={appManager}
                text={locManager.localizedStringForKey("LOGOUT_BUTTON")}
                onPress={() =>
                {
                  thisThing.stopScan();
                  thisThing.verifyLogout();
                }}
                />
              <View style={{margin:20}}>
                <View style={{flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                  <View style={{flex:1}}/>
                  <View>
                    <ReUpText isTitle={false} style={{color:generalTitleColor, textAlign:'center'}}>
                      {locManager.localizedStringForKey("SUBDOMAIN_LABEL")}
                    </ReUpText>
                  </View>
                  <View style={{width:5}}/>
                  <View>
                    <ReUpText isTitle={true} style={{color:generalTitleColor, textAlign:'center'}}>
                      {appManager._domain}
                    </ReUpText>
                  </View>
                  <View style={{flex:1}}/>
                </View>
                <View style={{flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                  <View style={{flex:1}}/>
                  <View>
                    <ReUpText isTitle={false} style={{color:generalTitleColor, textAlign:'center'}}>
                      {locManager.localizedStringForKey("EMAIL_LABEL")}
                    </ReUpText>
                  </View>
                  <View style={{width:5}}/>
                  <View>
                    <ReUpText isTitle={true} style={{color:generalTitleColor, textAlign:'center'}}>
                      {appManager.isLoggedIn() ? appManager.currentUser()[ModelConstants.UserName] : ""}
                    </ReUpText>
                  </View>
                  <View style={{flex:1}}/>
                </View>
              </View>
              {
                this.props.isDebugging ?
                <View style={{flexDirection:'row'}}>
                  <ReUpButton appManager={appManager} text={"PASS"} style={{margin:2, flex:1}}
                  onPress={() =>
                  {
                    var jsonString = JSON.stringify(passQR);
                    var base = btoa(jsonString)
                    thisThing.didScanData(base);
                  }}
                  />
                  <ReUpButton appManager={appManager} text={"CRED"} style={{margin:2, flex:1}}
                  onPress={() =>
                  {
                    var jsonString = JSON.stringify(creditQR);
                    var base = btoa(jsonString)
                    thisThing.didScanData(base);
                  }}
                  />

                  <ReUpButton appManager={appManager} text={"RWD"} style={{margin:2, flex:1}}
                  onPress={() =>
                  {
                    var jsonString = JSON.stringify(rewardQR);
                    var base = btoa(jsonString)
                    thisThing.didScanData(base);
                  }}
                  />

                  <ReUpButton appManager={appManager} text={"CHK"} style={{margin:2, flex:1}}
                  onPress={() =>
                  {
                    var jsonString = JSON.stringify(checkinQR);
                    var base = btoa(jsonString)
                    thisThing.didScanData(base);
                  }}
                  />

                  <ReUpButton appManager={appManager} text={"GC"} style={{margin:2, flex:1}}
                  onPress={() =>
                  {
                    var jsonString = JSON.stringify(giftCardQR);
                    var base = btoa(jsonString)
                    thisThing.didScanData(base);
                  }}
                  />

                  <ReUpButton appManager={appManager} text={"GAR"} style={{margin:2, flex:1}}
                  onPress={() =>
                  {
                    thisThing.didScanData(garbageQR);
                  }}
                  />

                </View>
                :
                null
              }
            </View>
          </View>
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
    backgroundColor:'white'
  },
  actionBarSpacer: {
    height:0,//Globals.ACTION_BAR_HEIGHT,
  },
  image: {
    position: 'absolute',
  },
});

TransactionScan.backOverride = function(appManager, appActions)
{
  appManager._eventEmitter.emit("stopScan");
  appActions.showLocalizedAlert("LOG_OUT_ALERT_TITLE", "LOG_OUT_ALERT_BODY", ["NO_ALERT_BUTTON","YES_ALERT_BUTTON"], [function()
  {
    appActions.hideAlert();
  },function()
  {
    appManager.logout(function()
    {
      appActions.requestPop();
      appActions.hideAlert();
    })
  }], function(){})
}

TransactionScan.dataDependencies = ["Rewards","Campaigns","Passes", "Users"]

module.exports = TransactionScan;
